import { useLocation, useNavigate } from "react-router-dom";
import { get, isUndefined } from "lodash";
import DSException from "./components/DS-V1/DSException-V1";
import DSExceptionV2 from "./components/DS-V2/DSException-V2";
import VATException from "./components/VAT/VATException";
import MOGException from "./components/MOG-V2/MOGException";
import { useEffect, useReducer } from "react";
import { EXCEPTION_INITIAL_STATE, exceptionReducer, exceptionReducerInit } from "./components/redux/exceptionTableReducer";
import { ROUTE_PATH_PHASTOS_PAGE } from "../../common/constants/route_paths";
import { UPDATE_STATUS_INITIAL_STATE, updateStatusReducer, updateStatusReducerInit } from "./components/redux/updateStatusReducer";
import { getPhastosObligationFromWorkflowType } from "./utils/utils";
import { PHASTOS_OBLIGATION } from "./components/common/constants";
import DSTException from "./components/DigitalServicesTax/DSTException";
import SpainSIIException from "./components/SPAIN_SII/SpainSIIException";

function WorkflowDetails(props) {
    const { domain, user } = props;
    const params = useLocation();
    const itemData = get(params, 'state.data', undefined);
    const workflowType = get(itemData, 'type', 'DATA_SHARING');
    const phastosObligation = getPhastosObligationFromWorkflowType(workflowType);
    const isAdjustmentEnabled = itemData?.featureFlags?.is_adjustment_enabled;
    
    const [exceptionSummaryData, exceptionSummaryDispatcher] = useReducer(exceptionReducer,
        EXCEPTION_INITIAL_STATE, exceptionReducerInit);
    const [updateWorkflowStatus, updateWorkflowStatusDispatcher] = useReducer(updateStatusReducer,
        UPDATE_STATUS_INITIAL_STATE, updateStatusReducerInit);

    const navigate = useNavigate();

    useEffect(() => {
        if (isUndefined(itemData)) {
            navigate(ROUTE_PATH_PHASTOS_PAGE);
            return;
        }

        // TODO: - Add actual API call over here & verify usecase
        let requestId = localStorage.getItem("requestId");
        exceptionSummaryDispatcher({
            type: "SET_REQUEST_ID", payload: {
                data: {
                    requestId,
                }
            }
        })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const getObligationSpecificException = (phastosObligation) => {
        switch (phastosObligation) {
            case PHASTOS_OBLIGATION.DS:
                return isAdjustmentEnabled ? (<DSExceptionV2
                    itemData={itemData}
                    exceptionSummaryData={exceptionSummaryData}
                    updateWorkflowStatus={updateWorkflowStatus}
                    updateWorkflowStatusDispatcher={updateWorkflowStatusDispatcher}
                />) : (<DSException
                    itemData={itemData}
                    exceptionSummaryData={exceptionSummaryData}
                    updateWorkflowStatus={updateWorkflowStatus}
                    updateWorkflowStatusDispatcher={updateWorkflowStatusDispatcher}
                />);
            case PHASTOS_OBLIGATION.MOG:
                return (<MOGException
                    alias={user}
                    itemData={itemData}
                    exceptionSummaryData={exceptionSummaryData}
                    updateWorkflowStatus={updateWorkflowStatus}
                    updateWorkflowStatusDispatcher={updateWorkflowStatusDispatcher}
                    domain={domain}
                />);
            case PHASTOS_OBLIGATION.DST:
                return (<DSTException
                    {...props}
                    itemData={itemData}
                    exceptionSummaryData={exceptionSummaryData}
                    updateWorkflowStatus={updateWorkflowStatus}
                    updateWorkflowStatusDispatcher={updateWorkflowStatusDispatcher}
                />);
            case PHASTOS_OBLIGATION.SPAIN_SII:
                return (<SpainSIIException
                    domain={domain}
                    itemData={itemData}
                    exceptionSummaryData={exceptionSummaryData}
                    updateWorkflowStatus={updateWorkflowStatus}
                    updateWorkflowStatusDispatcher={updateWorkflowStatusDispatcher}
                />)
            case PHASTOS_OBLIGATION.VAT:
            default:
                return (<VATException
                    domain={domain}
                    itemData={itemData}
                    exceptionSummaryData={exceptionSummaryData}
                    updateWorkflowStatus={updateWorkflowStatus}
                    updateWorkflowStatusDispatcher={updateWorkflowStatusDispatcher}
                />);
        }
    };
    
    return (
        <div>
            {getObligationSpecificException(phastosObligation)}
        </div>
    );
}

export default WorkflowDetails;